import { cn } from '@/lib/utils'

export interface PreviewLine {
  text: string
  tone?: 'muted' | 'highlight'
}

export interface DocumentPreviewProps {
  title: string
  lines: PreviewLine[]
  className?: string
}

export default function DocumentPreview({ title, lines, className }: DocumentPreviewProps) {
  return (
    <div className={cn('border border-border bg-surface p-5', className)}>
      <div className="flex items-center justify-between border-b border-border pb-3">
        <span className="text-sm font-mono text-foreground">{title}</span>
        <span className="text-xs font-mono text-foreground-muted">Preview</span>
      </div>
      <div className="mt-4 space-y-2 font-mono text-xs">
        {lines.map((line, index) => (
          <p
            key={`${line.text}-${index}`}
            className={cn(
              'leading-relaxed',
              line.tone === 'highlight' && 'text-primary',
              line.tone === 'muted' && 'text-foreground-muted',
              !line.tone && 'text-foreground-secondary'
            )}
          >
            {line.text}
          </p>
        ))}
      </div>
    </div>
  )
}
